var ValidationDisplay;
(function (ValidationDisplay) {
    ValidationDisplay[ValidationDisplay["OnTouchHighlight"] = 0] = "OnTouchHighlight";
    ValidationDisplay[ValidationDisplay["OnTouchShowMessage"] = 1] = "OnTouchShowMessage";
    ValidationDisplay[ValidationDisplay["OnTypeHighlight"] = 2] = "OnTypeHighlight";
    ValidationDisplay[ValidationDisplay["OnTypeShowMessage"] = 3] = "OnTypeShowMessage";
})(ValidationDisplay || (ValidationDisplay = {}));
var ESubmitState;
(function (ESubmitState) {
    ESubmitState[ESubmitState["PRE_SUBMIT"] = 0] = "PRE_SUBMIT";
    ESubmitState[ESubmitState["SUBMITTING"] = 1] = "SUBMITTING";
    ESubmitState[ESubmitState["POST_SUBMIT_SUCCESS"] = 2] = "POST_SUBMIT_SUCCESS";
    ESubmitState[ESubmitState["POST_SUBMIT_ERROR"] = 3] = "POST_SUBMIT_ERROR";
})(ESubmitState || (ESubmitState = {}));

export { ESubmitState, ValidationDisplay };
